// Odkrývání komentářů pomocí tlačítka ve vlákně

import * as els from './forumElements';
import { forumVerticalLine } from './forumVerticalLine';

export const forumShowMore = (): void => {
  // Pro všechny tlačítka 'Další komentáře(n)'
  els.buttonsShowMoreComments().forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', () => {
      const comments = button.parentElement?.parentElement?.querySelectorAll(
        '[data-comment-id]'
      ) as NodeListOf<HTMLDivElement>;
      // Odkrýt všechny komentáře
      comments.forEach((comment) => {
        comment.classList.remove(`${els.COMMENT_CLASS}--hidden`);
      });
      // Schovat tlačítko
      button.classList.add(`${els.COMMENT_CLASS}-more--hidden`);

      // přepočítání vodicích linek na původní koment
      setTimeout(() => {
        forumVerticalLine();
      }, 20);
    });
  });
};
